/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FEATURE_FLAG = "ALTERNATE_OLDEST_FIRST_VIEW" | "AVATARS" | "DEFAULT_QA_STORY_MODE" | "DISABLE_LIVE_UPDATES" | "DISABLE_WARN_USER_OF_TOXIC_COMMENT" | "DISCUSSIONS" | "EMAIL_META" | "ENABLE_AMP" | "ENABLE_QA" | "ENABLE_RATINGS_AND_REVIEWS" | "EXTERNAL_MEDIA" | "FLATTEN_REPLIES" | "NEW_COMMENT_COUNT" | "READ_MORE_NEW_TAB" | "REDUCED_SECURITY_MODE" | "RTE_SARCASM" | "SECTIONS" | "SITE_MODERATOR" | "VIEWER_COUNT" | "%future added value";
export type StreamContainer_settings = {
    readonly reaction: {
        readonly sortLabel: string;
    };
    readonly featureFlags: ReadonlyArray<FEATURE_FLAG>;
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"AnnouncementContainer_settings" | "CommunityGuidelinesContainer_settings" | "ModerateStreamContainer_settings" | "PostCommentFormContainer_settings" | "PreviousCountSpyContainer_settings" | "SuspendedInfoContainer_settings" | "UserBoxContainer_settings" | "ViewersWatchingContainer_settings">;
    readonly " $refType": "StreamContainer_settings";
};
export type StreamContainer_settings$data = StreamContainer_settings;
export type StreamContainer_settings$key = {
    readonly " $data"?: StreamContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"StreamContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ReactionConfiguration",
            "kind": "LinkedField",
            "name": "reaction",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sortLabel",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlags",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "DisableCommenting",
            "kind": "LinkedField",
            "name": "disableCommenting",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AnnouncementContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommunityGuidelinesContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerateStreamContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PostCommentFormContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PreviousCountSpyContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuspendedInfoContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBoxContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ViewersWatchingContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'd6963c7d73e4ecdf8e4cb6f3810b6fa3';
export default node;
